import React, { useEffect, useState } from "react"
import { cloneDeep } from "lodash"
import axios from "../http/axios"

import { useTranslation } from "react-i18next"

import XButtonIcon from "../svg/x-button.inline.svg"

import PlusIcon from "../svg/plus-icon.inline.svg"

import { useCurrentUser } from "../components/CurrentUserContext"
import { useSidemenu } from "../components/SidemenuContext"

import { notification } from "antd"

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
)
const SideNavApplyDocsSection = props => {
  const { isApplyDocsMenuOpen, toggleApplyDocsMenu } = useSidemenu()
  const [savedUserChildren, setSavedUserChildren] = useState()
  const { currentUser } = useCurrentUser()
  const school = props.school
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const openNotification = placement => {
    notification.info({
      message: t("school.feedback.sent"),
      placement,
    })
  }

  const openNotificationError = placement => {
    notification.info({
      message: t("school.feedback.notUploaded"),
      placement,
    })
  }

  useEffect(() => {
    if (isApplyDocsMenuOpen) {
      if (currentUser) {
        const obj = {
          authorEmail: currentUser?.email != null ? currentUser.email : "",
          authorFirstName:
            currentUser?.firstname != null ? currentUser.firstname : "",
          authorLastName:
            currentUser?.lastname != null ? currentUser.lastname : "",
          schoolManagerAccountId: "",
          content: "",
          meetingDate: "",
          meetingTime: "",
          languageCode: "",
          translatorNeeded: "",
          children: [
            {
              id: "",
              name: "",
              birthDate: "",
              admissionAge: "",
              documents: [],
            },
          ],
        }

        setFormValues(obj)

        axios
          .get(`/accounts/${currentUser?.id}/children`)
          .then(res => {
            setSavedUserChildren(res.data)
            getUserChildren(res.data)
          })
          .catch(error => {
            console.log("error", error)
          })
      } else {
        getUserChildren(null)
      }
    }
  }, [isApplyDocsMenuOpen])

  const [formValues, setFormValues] = useState({
    authorEmail: "",
    authorFirstName: "",
    authorLastName: "",
    content: "",
    schoolId: "",
    languageCode: "",
    children: [
      {
        id: "",
        name: "",
        birthDate: "",
        admissionAge: "",
        documents: [],
      },
    ],
  })
  const [nameTriggered, setNameTriggered] = useState(false)
  const [lastNameLengTriggered, setLastNameLengTriggered] = useState(false)
  const [emailTriggered, setEmailTriggered] = useState(false)

  const [errorSubmit, setErrorSubmit] = useState("")

  const [errorChildTriggered, setErrorChildTriggered] = useState("")

  let nameLengthZero = nameTriggered ? "email-not-valid" : ""
  let lastNameLengthZero = lastNameLengTriggered ? "email-not-valid" : ""
  let emailLengthZero = emailTriggered ? "email-not-valid" : ""

  const handleInputChanges = e => {
    e.persist()
    setFormValues(currValues => ({
      ...currValues,
      [e.target.name]: e.target.value,
    }))
    switch (e.target.name) {
      case "authorEmail":
        setEmailTriggered(false)
        break
      case "authorFirstName":
        setNameTriggered(false)
        break
      case "authorLastName":
        setLastNameLengTriggered(false)
        break
      default:
        break
    }
    setErrorSubmit("")
  }

  function validateChildren() {
    const isValidArr = []
    if (userChildren.length > 0) {
      userChildren.forEach(item => {
        if (item.name && item.birthDate && item.admissionAge) {
          isValidArr.push(true)
        } else {
          isValidArr.push(false)
        }
      })
    } else {
      inputList.forEach(item => {
        if (item.name && item.birthDate && item.admissionAge) {
          isValidArr.push(true)
        } else {
          isValidArr.push(false)
        }
      })
    }
    setErrorSubmit("")
    return isValidArr.every(el => el)
  }

  const [allDocs, setAllDocs] = useState([])
  //----ADD CHILD
  const [inputList, setInputList] = useState([
    { id: 0, name: "", birthDate: "", admissionAge: "", documents: [] },
  ])

  const handleAddClick = () => {
    setInputList([
      ...inputList,
      {
        id: 0,
        name: "",
        birthDate: "",
        admissionAge: "",
        documents: cloneDeep(allDocs),
      },
    ])
    setFormValues(currValues => {
      const newValues = { ...currValues }

      newValues.children.push({
        id: 0,
        name: "",
        birthDate: "",
        admissionAge: "",
        documents: [],
      })
      return { ...newValues }
    })
  }

  const handleRemoveClick = index => {
    const list = [...inputList]
    list.splice(index, 1)
    setInputList(list)

    const newList = [...formValues.children]
    newList.splice(index, 1)
    setFormValues(currValues => ({
      ...currValues,
      ["children"]: newList,
    }))
  }

  const handleInputChangeChildren = (e, index) => {
    setErrorChildTriggered("")
    const { name, value } = e.target
    const list = [...inputList]
    list[index][name] = value
    list[index].id = index
    setInputList(list)

    setFormValues(currValues => {
      const newValues = { ...currValues }
      const childArr = newValues.children

      const child = childArr[index]
      child[name] = value
      child["id"] = index
      return { ...newValues }
    })

    const isValidChildren = validateChildren()
    if (!isValidChildren) {
      setErrorChildTriggered("please fill the gaps")
    }
  }
  const handleInputChangeUserChildren = (e, index) => {
    setErrorChildTriggered("")
    const { name, value } = e.target
    const list = [...userChildren]
    list[index][name] = value
    list[index].id = index
    setUserChildren(list)
    setFormValues(currValues => {
      const newValues = { ...currValues }
      const childArr = newValues.children
      const child = childArr[index]
      child[name] = value
      child["id"] = index

      return { ...newValues }
    })
    const isValidChildren = validateChildren()
    if (!isValidChildren) {
      setErrorChildTriggered("please fill the gaps")
    }
  }

  //----ADD DOCS AND CHILDREN DATA
  const [userChildren, setUserChildren] = useState([])

  const handleAddClickChildren = () => {
    setUserChildren([
      ...userChildren,
      {
        id: 0,
        name: "",
        birthDate: "",
        admissionAge: "",
        documents: cloneDeep(allDocs),
      },
    ])

    // setFormValues(currValues => {
    //   const newValues = { ...currValues }
    //
    //   newValues.children.push({
    //     id: 0,
    //     name: "",
    //     birthDate: "",
    //     admissionAge: "",
    //     documents: []
    //   })
    //   return { ...newValues }
    // })
  }

  const getUserChildren = items => {
    if (items) {
      const userChildrenData = items
      for (let child of userChildrenData) {
        if (child.fullname) {
          child.name = child.fullname
          delete child.fullname
        }
        if (child.dateOfBirth) {
          child.birthDate = new Date(child.dateOfBirth)
            .toISOString()
            .slice(0, 10)
          delete child.dateOfBirth
        }
      }
      if (school.isSummer) {
        axios
          .get(
            `/summer-schools/${school.id}/required-documents?lang=${currentLang}`
          )
          .then(response => {
            setAllDocs(response.data)
            const userChildrenMapped = userChildrenData.map(item => {
              return { ...item, documents: cloneDeep(response.data) }
            })

            const formChildren = userChildrenData.map(item => {
              return { ...item, documents: [] }
            })
            setUserChildren(userChildrenMapped)
            setFormValues(currValues => {
              return Object.assign({}, currValues, {
                children: formChildren,
              })
            })
          })
          .catch()
      } else {
        axios
          .get(`/schools/${school.id}/required-documents?lang=${currentLang}`)
          .then(response => {
            setAllDocs(response.data)
            const userChildrenMapped = userChildrenData.map(item => {
              return { ...item, documents: cloneDeep(response.data) }
            })

            const formChildren = userChildrenData.map(item => {
              return { ...item, documents: [] }
            })
            setUserChildren(userChildrenMapped)
            setFormValues(currValues => {
              return Object.assign({}, currValues, {
                children: formChildren,
              })
            })
          })
          .catch()
      }
    } else {
      if (school.isSummer) {
        axios
          .get(
            `/summer-schools/${school.id}/required-documents?lang=${currentLang}`
          )
          .then(response => {
            setAllDocs(response.data)
            const userChildrenMapped = inputList.map(item => {
              return { ...item, documents: cloneDeep(response.data) }
            })

            const formChildren = inputList.map(item => {
              return { ...item, documents: [] }
            })
            setInputList(userChildrenMapped)

            setFormValues(currValues => {
              return Object.assign({}, currValues, { children: formChildren })
            })
          })
          .catch()
      } else {
        axios
          .get(`/schools/${school.id}/required-documents?lang=${currentLang}`)
          .then(response => {
            setAllDocs(response.data)
            const userChildrenMapped = inputList.map(item => {
              return { ...item, documents: cloneDeep(response.data) }
            })

            const formChildren = inputList.map(item => {
              return { ...item, documents: [] }
            })
            setInputList(userChildrenMapped)

            setFormValues(currValues => {
              return Object.assign({}, currValues, { children: formChildren })
            })
          })
          .catch()
      }
    }
  }

  const fileUpload = (e, docIdx, childIdx, currentDoc) => {
    const url = "/accounts/children/files/upload"
    const formData = new FormData()
    formData.append("file", e.target.files[0])
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
    axios
      .post(url, formData, config)
      .then(response => {
        setFormValues(currValues => {
          const newValues = { ...currValues }
          const childArr = newValues.children
          const child = childArr[childIdx]

          if (!child.documents) {
            child.documents = []
          }
          child.documents.push({
            id: currentDoc.documentId,
            fileName: response.data.filePath,
          })

          child.documents = child.documents
            .reverse()
            .filter((v, i, a) => a.findIndex(t => t.id === v.id) === i)
            .reverse()

          return { ...newValues }
        })

        if (!currentUser) {
          setInputList(currValues => {
            const newValues = [...currValues]
            const child = newValues[childIdx]
            Object.assign(child.documents[docIdx], { uploaded: true })
            return [...newValues]
          })
        } else {
          setUserChildren(currValues => {
            const newValues = [...currValues]
            const child = newValues[childIdx]
            Object.assign(child.documents[docIdx], { uploaded: true })
            return [...newValues]
          })
        }
      })
      .catch(e => {
        openNotificationError("topRight")
      })
  }

  const handleRemoveClickChildren = index => {
    const list = [...userChildren]
    list.splice(index, 1)
    setUserChildren(list)
  }

  function handleSubmit(e) {
    e.preventDefault()
    setErrorSubmit("")
    const isValidChildren = validateChildren()
    if (!isValidChildren) {
      setErrorChildTriggered("please fill the gaps")
    }
    if (!formValues.authorFirstName || formValues.authorFirstName === "") {
      setNameTriggered(true)
    }
    if (!formValues.authorLastName || formValues.authorLastName === "") {
      setLastNameLengTriggered(true)
    }

    if (!formValues.authorEmail || formValues.authorEmail === "") {
      setEmailTriggered(true)
    } else {
      validEmailRegex.test(formValues.authorEmail)
        ? setEmailTriggered(false)
        : setEmailTriggered(true)
    }
    if (
      formValues.authorLastName &&
      formValues.authorFirstName &&
      validEmailRegex.test(formValues.authorEmail) &&
      isValidChildren
    ) {
      axios
        .post("/applications", {
          authorEmail: formValues.authorEmail,
          authorFirstName: formValues.authorFirstName,
          authorLastName: formValues.authorLastName,
          schoolId: school.id,
          languageCode: currentLang,
          children: formValues.children,
          schoolMode: school.schoolMode,
          content: formValues.content,
        })
        .then(() => {
          getUserChildren(savedUserChildren)
          setErrorChildTriggered("")
          toggleApplyDocsMenu()
          openNotification("topRight")
        })
        .catch(error => {
          setErrorSubmit(error.response.data.message)
        })
    }
  }

  return (
    <>
      {isApplyDocsMenuOpen && (
        <div id="side-school-item-apply-docs" className="sidenav-school-item">
          {/* <!---- CLOSE BUTTON ----> */}

          <div className="sign-up-btn f-ac ps-5" onClick={toggleApplyDocsMenu}>
            <div className="x-button-wrapper f-ac f-jc curs-P">
              <XButtonIcon className="x-button" />
            </div>
            <div className="sign-up-text">{t("main.sideNav.close")}</div>
          </div>
          <div className="container">
            {/* <!-- FORM FIELDS --> */}
            <div className="side-nav-school-content">
              <div className="feedback-block-title mb-4">
                {t("school.feedback.applyDocs")}
              </div>
              <form onSubmit={handleSubmit} noValidate>
                <div className="name-email-fields feedback-fields">
                  <div className="input-group">
                    <input
                      type="text"
                      name="authorFirstName"
                      className={`form-field-error ${nameLengthZero}`}
                      required
                      value={formValues.authorFirstName}
                      onChange={handleInputChanges}
                    />
                    <label>{t("main.header.firstName")}</label>
                    {nameLengthZero && (
                      <span className={`error ${nameLengthZero}`}>
                        {t("main.header.ivalidData")}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <input
                      type="text"
                      name="authorLastName"
                      className={`form-field-error ${lastNameLengthZero}`}
                      required
                      value={formValues.authorLastName}
                      onChange={handleInputChanges}
                    />
                    <label>{t("main.userProfileMap.lastName")}</label>
                    {lastNameLengthZero && (
                      <span className={`error ${lastNameLengthZero}`}>
                        {t("main.header.ivalidData")}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <input
                      type="email"
                      name="authorEmail"
                      className={`form-field-error ${emailLengthZero}`}
                      required
                      value={formValues.authorEmail}
                      onChange={handleInputChanges}
                    />
                    <label>{t("main.header.email")}</label>
                    {emailLengthZero && (
                      <span className={`error ${emailLengthZero}`}>
                        {t("main.header.ivalidData")}
                      </span>
                    )}
                  </div>
                  <textarea
                    className="school-info-textarea feedback-fields"
                    placeholder={t("main.header.yourMessage")}
                    name="content"
                    value={formValues.content}
                    onChange={handleInputChanges}
                  />
                </div>
                {userChildren.length > 0
                  ? userChildren.map((x, i) => {
                      return (
                        <div
                          key={"input_" + i}
                          className="other-fields feedback-fields"
                        >
                          <div className="input-group">
                            <input
                              type="text"
                              name="name"
                              required
                              value={x.name}
                              onChange={e =>
                                handleInputChangeUserChildren(e, i)
                              }
                            />
                            <label>{t("main.header.childFullName")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="text"
                              name="birthDate"
                              required
                              onFocus={e => {
                                e.currentTarget.type = "date"
                                e.currentTarget.focus()
                              }}
                              onBlur={e => (e.currentTarget.type = "text")}
                              value={x.birthDate}
                              onChange={e =>
                                handleInputChangeUserChildren(e, i)
                              }
                            />
                            <label>{t("main.header.dateBirth")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="number"
                              name="admissionAge"
                              required
                              value={x.admissionAge}
                              onChange={e =>
                                handleInputChangeUserChildren(e, i)
                              }
                            />
                            <label>{t("main.header.planningSchool")}</label>
                          </div>

                          <div className="docs-attach-wrapper feedback-fields">
                            <div className="docs-title">
                              {t("school.feedback.applyDocsSelect")}
                            </div>
                            {x.documents.map((doc, idx) => {
                              return (
                                <div
                                  key={"doc_" + idx}
                                  className="docs-item f-jb f-ac"
                                >
                                  <div className="doc-name-wrapper f-js f-ac">
                                    <div
                                      className={`progress-point ${
                                        doc.uploaded ? "uploaded" : ""
                                      }`}
                                    ></div>
                                    <div className="doc-name">
                                      {doc.documentName}
                                    </div>
                                  </div>
                                  <div className="doc-input-wrapper f-je">
                                    <input
                                      type="file"
                                      id={"doc_" + idx + i}
                                      className="docsInput"
                                      hidden
                                      onChange={e => fileUpload(e, idx, i, doc)}
                                    />
                                    <label htmlFor={"doc_" + idx + i}>
                                      {t("school.feedback.applyDocsSelect")}
                                    </label>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                          <div className="add-child-wrapper f-js f-ac curs-P">
                            {userChildren.length - 1 === i && (
                              <>
                                <PlusIcon
                                  className="plus-icon"
                                  onClick={handleAddClickChildren}
                                />
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={handleAddClickChildren}
                                >
                                  {t("main.userProfileMap.addChild")}
                                </div>
                              </>
                            )}
                            {userChildren.length !== 1 &&
                              userChildren.length - 1 === i && (
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={() => handleRemoveClickChildren(i)}
                                >
                                  {t("main.userProfileTabs.removeChild")}
                                </div>
                              )}
                          </div>
                        </div>
                      )
                    })
                  : inputList.map((x, i) => {
                      return (
                        <div
                          key={"input_" + i}
                          className="other-fields feedback-fields"
                        >
                          <div className="input-group">
                            <input
                              type="text"
                              name="name"
                              required
                              value={x.name}
                              onChange={e => handleInputChangeChildren(e, i)}
                            />
                            <label>{t("main.header.childFullName")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="text"
                              name="birthDate"
                              required
                              onFocus={e => {
                                e.currentTarget.type = "date"
                                e.currentTarget.focus()
                              }}
                              onBlur={e => (e.currentTarget.type = "text")}
                              value={x.birthDate}
                              onChange={e => handleInputChangeChildren(e, i)}
                            />
                            <label>{t("main.header.dateBirth")}</label>
                          </div>
                          <div className="input-group">
                            <input
                              type="number"
                              name="admissionAge"
                              required
                              value={x.admissionAge}
                              onChange={e => handleInputChangeChildren(e, i)}
                            />
                            <label>{t("main.header.planningSchool")}</label>
                          </div>

                          <div className="docs-attach-wrapper feedback-fields">
                            <div className="docs-title">
                              {t("school.feedback.applyDocsSelect")}
                            </div>
                            {x.documents.map((doc, idx) => {
                              return (
                                <div
                                  key={"doc_" + idx}
                                  className="docs-item f-jb f-ac"
                                >
                                  <div className="doc-name-wrapper f-js f-ac">
                                    <div
                                      className={`progress-point ${
                                        doc.uploaded ? "uploaded" : ""
                                      }`}
                                    ></div>
                                    <div className="doc-name">
                                      {doc.documentName}
                                    </div>
                                  </div>
                                  <div className="doc-input-wrapper f-je">
                                    <input
                                      type="file"
                                      id={"doc_" + idx + i}
                                      className="docsInput"
                                      hidden
                                      onChange={e => fileUpload(e, idx, i, doc)}
                                    />
                                    <label htmlFor={"doc_" + idx + i}>
                                      {t("school.feedback.applyDocsSelect")}
                                    </label>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                          <div className="add-child-wrapper f-js f-ac curs-P">
                            {inputList.length - 1 === i && (
                              <>
                                <PlusIcon
                                  className="plus-icon"
                                  onClick={handleAddClick}
                                />
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={handleAddClick}
                                >
                                  {t("main.userProfileMap.addChild")}
                                </div>
                              </>
                            )}
                            {inputList.length !== 1 &&
                              inputList.length - 1 === i && (
                                <div
                                  className="user-nav-bar-option active"
                                  onClick={() => handleRemoveClick(i)}
                                >
                                  {t("main.userProfileTabs.removeChild")}
                                </div>
                              )}
                          </div>
                        </div>
                      )
                    })}

                <div className="style-errors-fillChildren">
                  {errorSubmit !== "" && (
                    <h3 className="style-errors-email"> {errorSubmit} </h3>
                  )}
                  {errorChildTriggered !== "" && (
                    <h3 className="style-errors-email">
                      {" "}
                      {t("school.feedback.fillChildren")}{" "}
                    </h3>
                  )}
                  <button
                    className="side-nav-school-item-submit-btn side-nav-school-margin"
                    type="submit"
                  >
                    {t("main.header.submit")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SideNavApplyDocsSection
